import styled from 'styled-components';
import { shade } from 'polished';
import iconUser from '../../../assets/icons/user.svg';
import avatarF from '../../../assets/icons/avatar-F.svg';
import avatarM from '../../../assets/icons/avatar-M.svg';
import { device } from '../../../styles/global';

export const Container = styled.div``;

export const Header = styled.header`
  padding: 32px 0;
  background: #28262e;
`;

export const HeaderContent = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  align-items: center;

  > img {
    height: 50px;
  }

  button {
    margin-left: auto;
    background: transparent;
    border: 0;

    svg {
      color: #999591;
      width: 20px;
      height: 20px;
    }
  }
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;
  margin-left: 80px;

  > svg {
  }

  div {
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    line-height: 24px;

    span {
      color: #f4ede8;
    }

    strong {
      color: #ff9000;
    }
  }
`;

export const Content = styled.main`
  max-width: 1120px;
  margin: 64px 10px;
  display: flex;

  @media ${device.tablet} {
    margin: 64px auto;
  }
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;

  h1 {
    color: #525f7f;
  }

  a {
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: 120px;
    height: 40px;
    max-height: 40px;
    display: flex;
    text-align: center;
    background: #1171ef;
    height: 56px;
    border-radius: 10px;
    border: 0;
    padding: 0 16px;
    color: #ffffff;
    text-decoration: none;
    width: 100%;
    font-weight: 500;
    margin-left: 10px;
    transition: background-color 0.2s;

    svg {
      margin-right: 15px;
    }

    &:hover {
      background: ${shade(0.2, '#1171ef')};
    }

    > * {
      margin: auto 0;
    }
  }
`;

export const Search = styled.div`
  display: flex;
  margin-bottom: 8px;

  > div {
    max-width: 100%;
  }

  > a {
    max-width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    background: #1171ef;
    height: 56px;
    border-radius: 10px;
    border: 0;
    padding: 0 16px;
    color: #ffffff;
    text-decoration: none;
    width: 100%;
    font-weight: 500;
    margin-left: 10px;
    transition: background-color 0.2s;

    &:hover {
      background: ${shade(0.2, '#1171ef')};
    }
  }
`;

export const Filter = styled.div`
  display: flex;

  > div {
    display: flex;

    & + div {
      margin-left: 15px;
    }
  }
`;

export const Schedule = styled.div`
  flex: 1;
  width: 100%;
  /* margin-right: 120px; */

  h1 {
    font-size: 36px;
  }

  p {
    margin-top: 8px;
    color: #000;
    display: flex;
    align-items: center;
    font-weight: 500;

    span {
      display: flex;
      align-items: center;
    }
    span + span::before {
      content: '';
      width: 1px;
      height: 12px;
      background: #ff9000;
      margin: 0 8px;
    }
  }

  Form {
    margin-top: 28px;
  }
`;

export const RowContainer = styled.ul`
  margin-top: 20px;
  list-style: none;
  width: 100%;
`;

interface AlunoProps {
  sexo?: number;
}

export const Row = styled.li<AlunoProps>`
  position: relative;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  background-color: #fff;

  border-radius: 5px;
  padding-right: 8px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
  border: 0;
  transition: box-shadow 0.15s ease;

  & + li {
    margin-top: 10px;
  }

  > div {
    display: flex;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    place-self: stretch flex-start;
    width: 100%;
    > div {
      &:nth-child(1) {
        background-color: rgb(18, 18, 20);
        margin-right: 16px;
        width: 50px;
        height: 50px;
        border-radius: 30px; //6px;
        /* background-image: url(${iconUser}); */
        background-image: url(${(props) => (props.sexo === 1 ? avatarM : avatarF)});
        background-repeat: no-repeat;
        background-size: cover;
        background-color: white;
      }

      &:nth-child(4) {
        justify-content: flex-end;
      }

      a {
        text-decoration: none;
        color: black;
      }
    }
  }
`;

export const Super = styled.span`
  margin-left: 10px;
  border-radius: 5px;
  color: white;
  font-size: 10px;
  padding: 5px;
  margin-bottom: 10px;
  background: #1171ef;
`;

export const Novo = styled.span`
  margin-left: 10px;
  border-radius: 5px;
  color: white;
  font-size: 10px;
  padding: 5px;
  margin-bottom: 10px;
  background: #ff9e00;
`;

export const Pagination = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

interface PageProps {
  selected?: boolean;
}

export const Page = styled.div<PageProps>`
  display: flex;

  align-items: center;
  background-color: ${(props) => (props.selected ? '#0357c6' : '#1171ef')}; // rgb(41, 41, 46);
  min-width: 40px;
  height: 40px;
  border-radius: 6px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  color: #fff;

  &:hover {
    background-color: #0357c6;
  }

  > div {
    margin: auto;
  }

  & + div {
    margin-left: 10px;
  }
`;

export const Arrow = styled.div`
  border-bottom: 2px solid #1e59f2;
  margin-bottom: 15px;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-top: 15px solid #1e59f2;
    border-left: 30px solid transparent;
    border-right: 30px solid transparent;
  }
`;

interface IconProps {
  vencido?: Date;
}

export const Icon = styled.img<IconProps>`
  width: 30px;
  height: 30px;
  margin-right: 15px;
  background: ${(props) => (props.vencido ? (new Date(props.vencido) < new Date() ? '#f70000' : '#44ff22') : '#fff')};
`;

export const SubDetails = styled.div`
  justify-content: space-around;
  margin-bottom: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 0 0 15px 15px;
  background: #fff;
  > img {
    margin: 0;
  }
`;

export const InputAreaStyled = styled.textarea`
  width: 100%;
`;
